import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, Badge, Alert } from 'react-bootstrap';
import Moment from 'moment';
import CustomSpinner from '../../components/CustomSpinner';
import { getBusinessMeRequest } from '../../actions/index';

class BusinessOverview extends Component {
  static propTypes = {
    getMe: PropTypes.func.isRequired,
    loadingProfile: PropTypes.bool,
    profile: PropTypes.shape({
      address: PropTypes.string,
      businessName: PropTypes.string,
      category: PropTypes.string,
      createdAt: PropTypes.any,
      email: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      phone: PropTypes.string,
      status: PropTypes.string,
    }),
  };

  componentDidMount() {
    this.props.getMe();
  }

  statusVariant(status) {
    if (status === 'active') return 'success';
    if (status === 'rejected') return 'danger';
    return 'warning';
  }

  render() {
    const { profile, loadingProfile } = this.props;

    if (loadingProfile) return <CustomSpinner />;

    if (!profile) {
      return (
        <Container className="pt-5">
          <Alert variant="warning">Unable to load your business profile. Please refresh.</Alert>
        </Container>
      );
    }

    return (
      <Container className="pt-5">
        <Row>
          <Col xs={12}>
            <h1 className="h1-list">Business Overview</h1>
          </Col>
          <Col xs={12} md={8} className="mt-4">
            <Card>
              <Card.Body>
                <Card.Title className="d-flex justify-content-between align-items-center">
                  <span>{profile.businessName}</span>
                  <Badge variant={this.statusVariant(profile.status)}>
                    {profile.status?.toUpperCase()}
                  </Badge>
                </Card.Title>
                <hr />
                <Row>
                  <Col sm={6}>
                    <p>
                      <strong>Email:</strong> {profile.email}
                    </p>
                    <p>
                      <strong>Category:</strong> {profile.category}
                    </p>
                    <p>
                      <strong>Phone:</strong> {profile.phone || '—'}
                    </p>
                  </Col>
                  <Col sm={6}>
                    <p>
                      <strong>Address:</strong> {profile.address}
                    </p>
                    <p>
                      <strong>Latitude:</strong> {profile.latitude}
                    </p>
                    <p>
                      <strong>Longitude:</strong> {profile.longitude}
                    </p>
                  </Col>
                </Row>
                <p className="text-muted mt-3">
                  <small>
                    Registered: {profile.createdAt ? Moment(profile.createdAt).format('LLL') : '—'}
                  </small>
                </p>
                {profile.status === 'pending' && (
                  <Alert variant="info" className="mt-3">
                    Your account is pending admin approval. You will be able to upload rewards once
                    approved.
                  </Alert>
                )}
                {profile.status === 'rejected' && (
                  <Alert variant="danger" className="mt-3">
                    Your account application was rejected. Please contact support for more
                    information.
                  </Alert>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.business.profile,
    loadingProfile: state.business.loadingProfile,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMe: () => dispatch(getBusinessMeRequest()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessOverview);
